import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SmWrapper from "../../Components/SmWrapper";
import Button from "../../tailwindUI/Button";
import Heading from "../../tailwindUI/Heading";
import Input from "../../tailwindUI/Input";
import StackedList from "../../tailwindUI/StackedList";
import classes from "../../module.css/SearchUpdate.module.css";
import ErrorMessage from "../../tailwindUI/ErrorMessage";
import Pagination from "../../tailwindUI/Pagination";
import DataNotFound from "../../Components/DataNotFound";
import FollowUpRemarks from "../../Components/FollowUpRemarks";
import Navbar from "../../tailwindUI/Navbar";
import Modal from "../../tailwindUI/Modal";

const CBTBookings = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [bookingList, setBookingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [bookingData, setBookingData] = useState([]);
  const [carRemarkOpen, setCarRemarkOpen] = useState(false);
  const [customerRemark, setCustomerRemark] = useState("");
  const [reminderDate, setReminderDate] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedBooking, setSelectedBooking] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = parseInt(queryParams.get("page")) || 1;
  const navigate = useNavigate();
  const UserToken = localStorage.getItem("UserToken");

  const LogOut = () => {
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  const validation = () => {
    let isValid = true;
    const error = {};
    if (!customerRemark.trim()) {
      isValid = false;
      error.customerRemark = "CBT Remark is required";
    }
    if (!reminderDate) {
      isValid = false;
      error.reminderDate = "Please select reminder date";
    }
    const today = new Date().toISOString().split("T")[0];
    if (reminderDate && reminderDate < today) {
      isValid = false;
      error.reminderDate = "Reminder date cannot be in the past";
    }
    setErrors(error);
    return isValid;
  };

  const searchApi = (searchType = "all") => {
    setLoading(true);
    setErrorMessage("");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    const payload = {
      UserToken,
      Outlet: localStorage.getItem("Location") || "Station Road",
      page,
      content: 20,
    };

    if (searchType === "text" || searchType === "all") {
      payload.SearchTerm = searchTerm || undefined;
    }

    if (searchType === "date" || searchType === "all") {
      payload.StartDate = startDate || undefined;
      payload.EndDate = endDate || undefined;
    }

    const raw = JSON.stringify(payload);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/srm/OutletwiseCarBookingList`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login" ||
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (
          result.status === "Success" &&
          result.status_code === 200 &&
          result.message === "data found successfully"
        ) {
          setBookingList(result.data);
          setCount(result.count);
        } else if (
          result.status === "Success" &&
          result.status_code === 200 &&
          result.message === "data not found "
        ) {
          setBookingList([]);
          setCount(0);
        } else if (result.status_code === 200 && result.status === "fail") {
          setBookingList([]);
          setCount(0);
        } else if (result.status_code === 400) {
          setErrorMessage(
            "Bad request. Please check your input or contact support."
          );
        } else {
          setErrorMessage("Unexpected error. Please contact support.");
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.log("Fetch aborted");
          return;
        }
        console.error("API error:", error);
        setErrorMessage(
          "Failed to fetch data. Please check your connection or contact support."
        );
      })
      .finally(() => setLoading(false));
  };

  // ... (BookingDetail and AMStockManagerRemarkUpdate remain unchanged)

  const BookingDetail = (bookingId) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      UserToken,
      BookingID: bookingId,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/srm/SRMBookingDetails_v1`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login" ||
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (result.status === "Success" && result.status_code === 200) {
          setBookingData(result.data);
        } else {
          setErrorMessage(
            "Failed to fetch booking details. Please contact support."
          );
        }
      })
      .catch((error) => {
        console.error("Booking detail error:", error);
        setErrorMessage(
          "Failed to fetch booking details. Please check your connection or contact support."
        );
      });
  };

  const AMStockManagerRemarkUpdate = () => {
    if (!validation()) return;

    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      UserToken,
      BookingID: selectedBooking?.BookingID,
      CBTRemark: customerRemark,
      ScheduleDate: reminderDate,
      MoveToConfirmCancel: "",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/am/MoveToConfirmCancelledAndCBTRemark`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login" ||
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (
          result.status_code === 200 &&
          result.message === "data updated successfully"
        ) {
          setErrorMessage("CBT Remark updated successfully");
          setCarRemarkOpen(false);
          setCustomerRemark("");
          setReminderDate("");
          setErrors({});
          searchApi("all");
        } else if (result.status_code === 300) {
          setErrors({
            ...errors,
            customerRemark: "CBT Remark cannot be empty",
          });
        } else {
          setErrorMessage(
            "Failed to update CBT remark. Please contact support."
          );
        }
      })
      .catch((error) => {
        console.error("Remark update error:", error);
        setErrorMessage(
          "Failed to update CBT remark. Please check your connection or contact support."
        );
      })
      .finally(() => setLoading(false));
  };

  const carBookingHandler = (item) => {
    setSelectedBooking(item);
    setCarRemarkOpen(true);
    setCustomerRemark(item.CBTRemark || "");
    setReminderDate(item.CBTRemarkScheduleDate || "");
    setErrors({});
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      searchApi("all");
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [page, searchTerm, startDate, endDate]);

  const maxPages = Math.ceil(count / 20);
  const BreadCrumb = {
    pagename: "CBT Bookings",
    pagePath: "/cbt-bookings",
  };

  const handleTextSearch = () => {
    if (searchTerm.length > 2) {
      searchApi("text");
    } else {
      setErrorMessage("Please enter a search term with at least 3 characters.");
    }
  };

  const handleDateSearch = () => {
    if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
      setErrorMessage("End date must be after start date.");
      return;
    }
    if (!startDate || !endDate) {
      setErrorMessage("Please select both start and end dates.");
      return;
    }
    searchApi("date");
  };

  const callApi = (e) => {
    if (e.key === "Enter" && searchTerm.length > 2) {
      handleTextSearch();
    }
  };

  return (
    <>
      <Navbar navbarType="CBT" />
      {carRemarkOpen && (
        <Modal
          setOpen={setCarRemarkOpen}
          heading={"CBT Remark"}
          open={carRemarkOpen}
          onCancel={() => {
            setCarRemarkOpen(false);
            setCustomerRemark("");
            setReminderDate("");
            setErrors({});
          }}
          onClick={AMStockManagerRemarkUpdate}
          type="Simple alert"
        >
          <div className="mt-2">
            <Input
              type={"textarea"}
              label="CBT Remark"
              placeholder="Enter CBT Remark"
              value={customerRemark}
              onChange={(e) => {
                setCustomerRemark(e.target.value);
                setErrors({ ...errors, customerRemark: "" });
              }}
            />
            {errors.customerRemark && (
              <span className="text-red-600 text-sm">
                {errors.customerRemark}
              </span>
            )}
          </div>
          <div className="mt-2">
            <Input
              type={"input with label"}
              label="Set Reminder"
              inputType="date"
              value={reminderDate}
              onChange={(e) => {
                setReminderDate(e.target.value);
                setErrors({ ...errors, reminderDate: "" });
              }}
              error={errors.reminderDate}
              onKeyDown={(e) => e.preventDefault()}
            />
            {errors.reminderDate && (
              <span className="text-red-600 text-sm">
                {errors.reminderDate}
              </span>
            )}
          </div>
        </Modal>
      )}
      <div>
        {open && (
          <FollowUpRemarks
            bookingData={bookingData}
            setOpen={setOpen}
            open={open}
          />
        )}
        <Heading
          headingType="Page Headings"
          BreadCrumHomeLink="/cbt-dashboard"
          headingText=""
          BreadCrumb={BreadCrumb}
        />
        <div className={classes.mainContainer}>
          {errorMessage && <ErrorMessage message={errorMessage} />}
          <div className={classes.searchContainer}>
            <h2 className={classes.searchHeading}>Search Criteria</h2>
            <div className="flex justify-between">
              <div className="w-full flex">
                <div className={classes.inputWrapper}>
                  <Input
                    type="input with label"
                    placeholder="For Ex:- Customer Name, Customer Mobile, Model, Variant, Colour, Fuel Type, ASM"
                    inputType="search"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={callApi}
                  />
                </div>
                <div className="mt-1">
                  <Button
                    buttonText="Search"
                    type="SearchButton"
                    onClick={handleTextSearch}
                  />
                </div>
              </div>
              <div
                style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}
              >
                <div className={classes.inputWrapper}>
                  <Input
                    type="input with label"
                    label="Start Date"
                    inputType="date"
                    onChange={(e) => setStartDate(e.target.value)}
                    value={startDate}
                  />
                </div>
                <div className={classes.inputWrapper}>
                  <Input
                    type="input with label"
                    label="End Date"
                    inputType="date"
                    onChange={(e) => setEndDate(e.target.value)}
                    value={endDate}
                  />
                </div>
                <div className="mt-3">
                  <Button
                    buttonText="Search"
                    type="SearchButton"
                    onClick={handleDateSearch}
                  />
                </div>
              </div>
            </div>
          </div>
          {bookingList.length !== 0 && (
            <div className="flex px-4 justify-between items-center text-gray-500">
              <div className="flex items-center">
                <div className="mr-1 bg-green-600 w-2 h-2"></div>
                <span className="text-xs">Allocated Cars</span>
              </div>
              <div className="my-2 text-end">
                <p className="text-sm italic text-gray-500 mr-1">
                  {bookingList.length} of {count} results
                </p>
              </div>
            </div>
          )}
          <div className="bg-white overflow-x-auto">
            {loading ? (
              <div className={classes.loader}>
                <img src="/assets/loading.gif" alt="loading" />
              </div>
            ) : (
              <div className="bg-white w-auto min-w-[1079px]">
                {bookingList.length === 0 ? (
                  <DataNotFound />
                ) : (
                  <div className={classes.stackListContainer}>
                    <div role="list" className={classes.stackListWrapper}>
                      {bookingList.map((item, index) => (
                        <StackedList
                          type="update booking"
                          ListType="nobutton"
                          outlet="kanpur"
                          item={item}
                          key={index}
                          id={index}
                          setOpen={setOpen}
                          BookingDetail={BookingDetail}
                          carBookingHandler={carBookingHandler}
                          setCustomerRemark={setCustomerRemark}
                          setReminderDate={setReminderDate}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          {maxPages > 1 && <Pagination maxPages={maxPages} />}
        </div>
      </div>
    </>
  );
};

export default CBTBookings;
